module.exports = __webpack_public_path__ + "img/grid-3.48b1bf69.svg";